// extracted by mini-css-extract-plugin
export default {"detailContainer":"NewDetail_detailContainer__kkdsR","detailInfo":"NewDetail_detailInfo__4g98B","date":"NewDetail_date__5CH8M","description":"NewDetail_description__xk8qK"};